import { Link } from 'react-router-dom';
import { footerLinks, siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 font-bold text-sm">
                日
              </span>
              <span className="font-heading font-semibold text-lg">{siteInfo.logo}</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-100">
              <a href="/category/zone-one" className="hover:text-accent-400 transition-colors duration-200">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-100">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-100">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li>{siteInfo.address}</li>
              <li>
                <a href={`mailto:${siteInfo.email}`} className="hover:text-accent-400 transition-colors duration-200">
                  {siteInfo.email}
                </a>
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a
                href={siteInfo.social.twitter}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-accent-500 transition-colors duration-200"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a
                href={siteInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-accent-500 transition-colors duration-200"
                aria-label="Facebook"
              >
                <i className="ri-facebook-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-400">
            &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
          <p className="text-xs text-background-500">
            本网站内容仅供参考，出行前请确认最新信息
          </p>
        </div>
      </div>
    </footer>
  );
}